class LocalStorage {
  constructor(key) {
    this.key = key;

    this.cache = {};

    try {
      // let cacheItems = window?.localStorage?.get(this.key);
      // this.cache = JSON.parse(cacheItems);
    } catch(e) {
      // silent error
    }
  }

  get(key) {
    return this.cache[key];
  }

  set(key, value) {
    this.cache[key] = value;
    return this;
  }

  unset(key) {
    delete this.cache[key];
    return this;
  }

  toJSON() {
    return { ...this.cache };
  }

  save() {
    window.localStorage.set(this.key, {
      data: JSON.stringify(this.cache),
      updated_at: new Date().toISOString()
    });
  }
}

export default LocalStorage;